import type { App } from "vue";
import PersonInfoState from "@/branchmanager/app/workspace/applicant/person/personInfo/PersonInfoState.vue";
import BusinessInfoState from "@/branchmanager/app/workspace/applicant/business/businessInfo/BusinessInfoState.vue";
import ProductSelectionState from "@/branchmanager/app/workspace/enrollment/productselection/ProductSelectionState.vue";

export function reuseAllOpenComponents(app: App) {
    app.component("BltPersonInfoState", PersonInfoState);
    app.component("BltBusinessInfoState", BusinessInfoState);
    app.component("BltProductSelectionState", ProductSelectionState);
}